import React from "react";
import { useRootAppStore } from "@hooks";
import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";

export default function ChatMinimizeButton() {
	const { chatViewStore } = useRootAppStore();

	const minimizeChatWindow = () => {
		chatViewStore.toggleChatBox(false);
	};

	return (
		<ErrorBoundaryWithPropagation
			componentName={"Mobile/ChatMinimizeButton.tsx"}
		>
			<button
				className="btn btn--square btn--square--sml btn--icon btn--primary--inverted"
				onClick={minimizeChatWindow}
			>
				<i className="u-icon u-icon--tny u-icon--minimize" />
			</button>
		</ErrorBoundaryWithPropagation>
	);
}
